// ENTITY fr.gestionpial.pial.dto.PropositionAffectationDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { ScoringDetailDTO } from './ScoringDetailDTO';

export class PropositionAffectationDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.PropositionAffectationDTO';

  idAesh: number | null = 0;
  aeshNom: string | null = '';
  aeshPrenom: string | null = '';
  volumeContrat: number | null = 0;
  aeshCo: boolean | null = false;
  idEcole: number | null = 0;
  ecoleNom: string | null = '';
  volumeHoraire: number | null = 0;
  reserve: boolean | null = false;
  scoring: ScoringDetailDTO | null = null;
  aeshAbsente: boolean | null = false;
  absenceDebut: Date | null = null;
  absenceFin: Date | null = null;

  constructor(init?:Partial<PropositionAffectationDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.PropositionAffectationDTO'] = PropositionAffectationDTO;

fields['fr.gestionpial.pial.dto.PropositionAffectationDTO']  = {
    idAesh: 'java.lang.Integer',
    aeshNom: 'java.lang.String',
    aeshPrenom: 'java.lang.String',
    volumeContrat: 'java.lang.Integer',
    aeshCo: 'java.lang.Boolean',
    idEcole: 'java.lang.Integer',
    ecoleNom: 'java.lang.String',
    volumeHoraire: 'java.lang.Integer',
    reserve: 'java.lang.Boolean',
    scoring: 'fr.gestionpial.pial.dto.ScoringDetailDTO',
    aeshAbsente: 'java.lang.Boolean',
    absenceDebut: 'java.time.LocalDate',
    absenceFin: 'java.time.LocalDate'
};
